module.exports = __webpack_public_path__ + "static/media/2122-service-2-4-min.429005d7.jpg";